import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private userSubject: BehaviorSubject<any | null>;
  public user$: Observable<any | null>;

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) {

    const storedUser = localStorage.getItem('currentUser');

    this.userSubject = new BehaviorSubject<any | null>(
      storedUser ? JSON.parse(storedUser) : null
    );

    this.user$ = this.userSubject.asObservable();
  }

  // =========================
  // LOGIN
  // =========================
  public login(usuario: any): Observable<any> {
    const apiurl = `api/usuarios/authenticate`;

    return this.http.post<any>(apiurl, usuario, this.httpOptions).pipe(
      map((user) => {

        const sessionUser = {
          id: user.id,
          login: user.login,
          nome: user.nome,
          isAdmin: user.isAdmin,
          token: user.token || user.Token   // 🔥 FIX CRÍTICO
        };

        localStorage.setItem('currentUser', JSON.stringify(sessionUser));
        this.userSubject.next(sessionUser);

        return sessionUser;
      })
    );
  }

  // =========================
  // LOGOUT
  // =========================
  public logout(): void {
    localStorage.removeItem('currentUser');
    this.userSubject.next(null);
  }

  // =========================
  // USER STATE
  // =========================
  public getUser(): any | null {
    return this.userSubject.value;
  }

  public isAuthenticated(): boolean {
    return !!this.userSubject.value?.token;
  }

  public isAdmin(): boolean {
    return this.userSubject.value?.isAdmin === true;
  }

  // =========================
  // TOKEN ACCESS (Interceptor)
  // =========================
  public getToken(): string | null {
    return this.userSubject.value?.token || null;
  }

  // =========================
  // OPTIONAL: VALIDACAO SIMPLE TOKEN EXPIRATION (sem lib externa)
  // =========================
  public isTokenExpired(): boolean {
    const token = this.getToken();
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp;

      if (!exp) return false;

      return Date.now() >= exp * 1000;
    } catch {
      return true;
    }
  }

  // =========================
  // OBSERVABLE REACTIVO
  // =========================
  public userChanges(): Observable<any | null> {
    return this.user$;
  }
}